"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setLabelAction = (_a = createFeature_1.createInputFeature('label'), _a.actionCreator), exports.labelSelector = _a.selectorCreator, exports.LabelFeature = _a.featureReducer;
//# sourceMappingURL=label.js.map